import { useSelector } from 'react-redux';
import { RootState } from '$store/rootReducer';
import { imChatInfoSelector } from '$store/im';
import { ImChatInfo } from '$store/im/interface';

export function useChatInfo(peerId: number): ImChatInfo {
  return useSelector((state: RootState) => imChatInfoSelector(state, peerId));
}
